// Module
var code = "<div class=\"sw-video\"> <video loop muted poster=\"{{ $ctrl.video.image }}\"> <source src=\"{{ $ctrl.video.file }}\" type=\"video/mp4\"/> </video> </div> ";
// Exports
export default code;